// @flow
import Loadable from 'react-loadable'

import Loader from '@src/components/ui/ReactLoadableLoader'

const CleaningServiceReportsLoader = Loadable({
  loader: () => import('./CleaningServiceReportsContainer'),
  loading: Loader,
})

export default CleaningServiceReportsLoader
